<script>

import Navbar from '@/components/Navbar'
import staff from '@/helpers/staff'
import GlobalComputed from '@/helpers/global-computed'

export default {
  name: 'staff',
  components: { Navbar },
  data(){
    return {
      staff,
      loginId: '',
      loginMessage: ''
    }
  },
  computed: {
    ...GlobalComputed,
    locale(){
      return this.$i18n.locale === 'de' ? 'de' : 'en';
    }
  },
  methods: {
    submitLogin(){
      this.loginMessage = this.$t('staff.login.sent');
    },
    roleFor(person){
      return person.role[this.locale] || person.role.en;
    }
  }
}
</script>

<template>
  <div>
    <navbar :lightTheme="true" :blogpost="true" />

    <v-container class="staff-page py-12">
      <h1 class="primary--text mb-2">{{ $t('staff.title') }}</h1>
      <p class="staff-page__subtitle mb-8">{{ $t('staff.subtitle') }}</p>

      <v-row>
        <v-col v-for="person in staff"
               :key="person.name"
               :cols="isPc ? 3 : 6"
               class="text-center mb-6">
          <div class="staff-avatar dark-gradient mx-auto mb-3 d-flex align-center justify-center">
            <img v-if="person.photo" :src="person.photo" :alt="person.name" class="staff-avatar__img" />
            <span v-else class="staff-avatar__initials">{{ person.initials }}</span>
          </div>
          <div class="staff-name primary--text">
            {{ person.name }}
            <span v-if="person.pronouns" class="staff-pronouns">({{ person.pronouns }})</span>
          </div>
          <div class="staff-role">{{ roleFor(person) }}</div>
          <v-btn v-if="person.linkedin"
                 :href="person.linkedin"
                 target="_blank"
                 icon
                 small
                 color="blue"
                 aria-label="LinkedIn">
            <v-icon>mdi-linkedin</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="my-10" />

      <v-row justify="center">
        <v-col :cols="isPc ? 5 : 12">
          <h2 class="primary--text mb-4">{{ $t('staff.login.title') }}</h2>
          <v-form @submit.prevent="submitLogin">
            <v-text-field v-model="loginId"
                          :label="$t('staff.login.placeholder')"
                          outlined
                          dense
                          class="mb-2" />
            <v-btn color="primary" dark depressed type="submit">{{ $t('staff.login.button') }}</v-btn>
          </v-form>
          <v-alert v-if="loginMessage" type="info" outlined class="mt-4">
            {{ loginMessage }}
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>

.staff-page {
  max-width: 960px;
}

.staff-page__subtitle {
  opacity: 0.7;
}

.dark-gradient {
  background-color: #050a19!important;
  background: linear-gradient(125deg, rgba(5,10,25,1) 45%, rgb(3, 16, 53) 100%)!important;
}

.staff-avatar {
  width: 160px;
  max-width: 100%;
  aspect-ratio: 1;
  border-radius: 4px;
  overflow: hidden;
}

.staff-avatar__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.staff-avatar__initials {
  color: white;
  font-size: 1.6rem;
  font-weight: 500;
  letter-spacing: 0.05em;
}

.staff-name {
  font-weight: 600;
}

.staff-pronouns {
  font-weight: 400;
  font-size: 0.85rem;
  opacity: 0.6;
}

.staff-role {
  font-size: 0.9rem;
  opacity: 0.7;
}

</style>
